var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-bar-link" }, [
    _c(
      "a",
      {
        class: _vm.statusClass,
        attrs: { href: _vm.anchor },
        on: { click: _vm.updateActiveLink }
      },
      [_vm._v(_vm._s(_vm.$resourceString["" + _vm.title]))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }